import { Component, OnInit } from '@angular/core';
import { ProfileUserService } from "../../service/profile-user.service";
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-profile-user',
  templateUrl: './profile-user.component.html',
  styleUrls: ['./profile-user.component.scss'],
  providers: [ProfileUserService]
})
export class ProfileUserComponent implements OnInit {

  private profiles;
  private dataRows;
  private query = '';
  private selectedCTC;
  private selectedCTCIndex;
  private selectedProfile;
  private selectedProfileIndex;

  private changedCTC; // CTC that was changed (input)
  private changedProfileIndex; // Profiles that was changed (Input)
  private tempUser; // User selected to save

  private filtro = {
    usuario: '',
    CTC: '',
    GC: ''
  }

  users = [];
  userList = [];
  filteredList = [];
  allSaved = true; //Do some field have some unsaved change?
  private tempElement // Hold the changed Element reference

  constructor(private profileUserService: ProfileUserService, private flashMessagesService: FlashMessagesService ) { }

  ngOnInit() {
    this.getUsers();
    //this.getProfileEdit();
    this.getProfiles();
  }

  tableScroll(){
      $(".userProfileTable thead tr th:nth-child(1)").css("left", $(".userProfileDiv").scrollLeft() - 1);
      $(".userProfileTable tbody tr td:nth-child(1)").css("left", $(".userProfileDiv").scrollLeft() - 1);
      $(".userProfileTable thead tr th").css("top", $(".userProfileDiv").scrollTop() -1);
  }
  
select(item){
  this.tempElement.value = item.userName;
  this.saveProfile(this.changedCTC, this.changedProfileIndex, item);
  this.filteredList = [];
  this.allSaved = true;
}

getUsers(){
  this.profileUserService.getUsers().subscribe(result =>{
    this.users = result.Result;
    this.users.forEach(user =>{
      this.userList.push({
        userName: user.Nome+" ("+user.Login+")",
        userID: user.ID
      });
    });
  });
  console.log(this.userList);
} 

filter(event){
  this.query = event.target.value;
  this.changedCTC = this.selectedCTC;
  this.changedProfileIndex = this.selectedProfileIndex;
  this.tempElement = (<HTMLInputElement>document.getElementById(this.selectedCTCIndex+"-"+this.selectedProfileIndex));
  this.allSaved = false;
   if (this.query !== ""){
        this.filteredList = this.userList.filter(function(el){
            return el.userName.toLowerCase().indexOf(this.query.toLowerCase()) > -1;
        }.bind(this));
    }else{
        this.filteredList = [];
    }
}

onFocusInput(ctcIndex, profileIndex, event){
  this.filteredList = [];
  this.selectedCTC = this.dataRows[ctcIndex];
  this.selectedCTCIndex = ctcIndex;
  this.selectedProfileIndex = profileIndex;
  this.selectedProfile = this.profiles[profileIndex];

  //On focus other field is checked the change before to save or not...
  if (!this.allSaved){

    if (this.query == ""){
      this.saveProfile(this.changedCTC, this.changedProfileIndex, null);
      this.allSaved = true;
    } else{
            this.tempUser = this.userList.filter( user => 
            user.userName.toLowerCase().indexOf(this.query.toLowerCase()) > -1);
            
            if (this.tempUser.length == 1){
              this.tempElement.value = this.tempUser[0].userName;
              this.saveProfile(this.changedCTC, this.changedProfileIndex, this.tempUser[0]);
              this.allSaved = true;
            }else{
              if (this.tempUser.length > 1){
                this.flashMessagesService.show('Multiplos usuários encontrados, nenhuma alteração salva!', { cssClass: 'alert-danger', timeout: 6000 });
                if (this.changedCTC.Perfis[this.changedProfileIndex + 1]){
                  this.tempElement.value = this.changedCTC.Perfis[this.changedProfileIndex + 1];
                  this.allSaved = true;
                }else{
                  this.tempElement.value = '';
                  this.allSaved = true; 
                }
              }else{
                this.flashMessagesService.show('Nenhum usuário encontrado, nenhuma alteração salva!', { cssClass: 'alert-danger', timeout: 6000 });
                if (this.changedCTC.Perfis[this.changedProfileIndex + 1]){
                    this.tempElement.value = this.changedCTC.Perfis[this.changedProfileIndex + 1];
                    this.allSaved = true;
                  }else{
                    this.tempElement.value = '';
                    this.allSaved = true; 
                  }
              }
            }
          }
    }
}

getProfileEdit(){
  this.profileUserService.getProfileEdit(this.filtro).subscribe(result =>{
   
  const response = result.Result;
 
    this.dataRows = response.map( item => ({
      ...item,
      Perfis: item.Perfis.reduce((dic, perfil) => {
        dic[perfil.Ordem] = perfil.NomeLogin;
       
        return dic;
      }, {} as {[key: number]: string})
    }));
  });
 
  console.log(this.dataRows)
   
}

getProfiles(){
  this.profileUserService.getProfile().subscribe(result =>{
    this.profiles = result.Result;
  });
}

saveProfile(CTC, profileID, user){

  if (user != null) {
    var obToSave = {
    CodigoSap: CTC.CodCTC,
    PerfilId: this.profiles[profileID].ID,
    UsuarioId : user.userID
    }
  }else{
    var obToSave = {
    CodigoSap: CTC.CodCTC,
    PerfilId: this.profiles[profileID].ID,
    UsuarioId : null
    }
  }
  this.profileUserService.saveProfile(obToSave).subscribe(result => {
   if (result.Success){
    this.flashMessagesService.show('Alteração salva com sucesso!', { cssClass: 'alert-success', timeout: 6000 });
    
  }else{
    this.flashMessagesService.show('Erro ao salvar.', { cssClass: 'alert-danger', timeout: 6000 });
  }
  });
}

}



// WEBPACK FOOTER //
// ./src/app/profile-user/component/profile-user/profile-user.component.ts